import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { getAccountShortLabel, setActiveAccountId } from 'utils/accountContext';

export default function AccountSwitcher() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { switchableAccounts, activeAccountId } = useSelector((state) => state.user);

  if (!switchableAccounts?.length || switchableAccounts.length < 2) {
    return null;
  }

  const handleSwitch = (accountId) => {
    if (String(accountId) === String(activeAccountId)) return;
    setActiveAccountId(accountId);
    window.location.assign('/dashboard/main');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: isMobile ? 0.5 : 0.75,
        ml: { xs: 0.75, md: 2 },
        flexShrink: 0,
      }}
    >
      {switchableAccounts.map((account) => {
        const isActive = String(activeAccountId) === String(account._id);
        const label = isMobile ? getAccountShortLabel(account.name) : account.name;
        return (
          <Button
            key={account._id}
            size="small"
            onClick={() => handleSwitch(account._id)}
            title={account.name}
            aria-label={`Switch to ${account.name}`}
            sx={{
              minWidth: isMobile ? 36 : 0,
              px: isMobile ? 1 : 1.5,
              py: 0.5,
              borderRadius: 999,
              textTransform: 'none',
              fontWeight: 700,
              fontSize: isMobile ? 11 : 12,
              lineHeight: 1,
              color: isActive ? '#111' : '#fff',
              bgcolor: isActive ? '#95F205' : 'rgba(255,255,255,0.08)',
              border: isActive ? '1px solid #95F205' : '1px solid rgba(255,255,255,0.18)',
              '&:hover': {
                bgcolor: isActive ? '#95F205' : 'rgba(149, 242, 5, 0.12)',
                borderColor: '#95F205',
              },
            }}
          >
            {label}
          </Button>
        );
      })}
    </Box>
  );
}
